import React from "react";

const Footer = () => {
	return (
		<footer>
			<p>Powered by the MTG API (<a rel="noopener noreferrer" href="https://magicthegathering.io/" target="_blank">visit</a>)</p>
		</footer>
	)
}

export default Footer;